
import axios from "axios";
import { API_URL } from "src/scenes/App";
import { UserKeys } from "src/constants/userDetails";

export const fetchCoverByUuid = async (videoUuid) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const res = await axios.get(`${API_URL}/company/bodyAndMind/contents/video/${videoUuid}`, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return res.data;
};

export const fetchCategoryByUuid = async (categoryUuid) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const res = await axios.get(`${API_URL}/company/bodyAndMind/categories/video/${categoryUuid}`, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return res.data; 
};